// @ts-nocheck
// tool-retention.js — Retention Revenue Score behaviour (SSM-631).
//
// Math ported verbatim from the Vercel app's src/lib/retention.ts. Every constant,
// category target, flow weight and band threshold is read out of the DOM that
// snippets/tool-retention.liquid rendered, so the numbers exist in exactly one place
// and the visible copy cannot drift from the math.
//
// Writes computed values into existing nodes and toggles which pre-rendered sentence
// is shown. It never builds DOM.
(function () {
  var roots = document.querySelectorAll('[data-tool="retention"]');
  if (!roots.length) return;

  function usd(n) {
    return n.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    });
  }

  // Round before formatting, so a displayed "$0" always means the underlying gap
  // rounded to zero — which is what the accompanying copy branches on.
  function money(n) {
    return isFinite(n) ? usd(Math.round(n)) : usd(0);
  }

  function pct(n) {
    return Math.round(n * 10) / 10 + '%';
  }

  // Same shape as tool-roas's helper so numeric entry behaves identically.
  function parseNum(raw) {
    var cleaned = String(raw).replace(/[^0-9.]/g, '');
    if (cleaned === '') return null;
    var n = Number(cleaned);
    return isFinite(n) && n >= 0 ? n : null;
  }

  function numOr0(raw) {
    var n = parseNum(raw);
    return n == null ? 0 : n;
  }

  function clampPercent(v) {
    if (!isFinite(v)) return 0;
    return Math.min(100, Math.max(0, v));
  }

  function tidy(node) {
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function mount(root) {
    if (root.dataset.toolMounted) return;
    root.dataset.toolMounted = 'true';

    var MIX_TARGET = Number(root.getAttribute('data-mix-target'));
    var W_REPEAT = Number(root.getAttribute('data-weight-repeat'));
    var W_MIX = Number(root.getAttribute('data-weight-mix'));
    var W_COVERAGE = Number(root.getAttribute('data-weight-coverage'));
    var MAX_REVENUE = Number(root.getAttribute('data-max-revenue'));
    if (!isFinite(MIX_TARGET) || !isFinite(MAX_REVENUE)) return;

    // Bounded, non-negative money. Without the ceiling a pasted exponent makes the
    // annualised gaps overflow to Infinity and render as "$∞".
    function clampMoney(v) {
      if (!isFinite(v) || v < 0) return 0;
      return Math.min(MAX_REVENUE, v);
    }

    var verticalSelect = root.querySelector('[data-ret-vertical]');
    var fields = {};
    root.querySelectorAll('[data-ret-input]').forEach(function (el) {
      fields[el.getAttribute('data-ret-input')] = el;
    });
    if (!verticalSelect || !fields.revenue) return;

    var out = {};
    root.querySelectorAll('[data-ret-out]').forEach(function (el) {
      out[el.getAttribute('data-ret-out')] = el;
    });

    var notes = {};
    root.querySelectorAll('[data-ret-note]').forEach(function (el) {
      notes[el.getAttribute('data-ret-note')] = el;
    });

    var summaries = {};
    root.querySelectorAll('[data-ret-summary]').forEach(function (el) {
      summaries[el.getAttribute('data-ret-summary')] = el;
    });

    var priorities = {};
    root.querySelectorAll('[data-ret-priority]').forEach(function (el) {
      priorities[el.getAttribute('data-ret-priority')] = el;
    });

    // Flows, in document order, which is the heaviest-first order the lib defines.
    var flows = [];
    root.querySelectorAll('[data-ret-flow]').forEach(function (el) {
      flows.push({
        id: el.getAttribute('data-ret-flow'),
        weight: Number(el.getAttribute('data-flow-weight')),
        input: el,
        name: tidy(el.parentNode.querySelector('.tool-ret__flow-name'))
      });
    });

    // Bands, read from the reference grid and sorted high-to-low so the first
    // threshold met wins — matching bandFor()'s predicate approach.
    var bands = [];
    root.querySelectorAll('[data-ret-band]').forEach(function (el) {
      bands.push({
        key: el.getAttribute('data-ret-band'),
        min: Number(el.getAttribute('data-min')),
        label: tidy(el.querySelector('.tool-ret__band-label'))
      });
    });
    bands.sort(function (a, b) {
      return b.min - a.min;
    });
    if (!flows.length || !bands.length) return;

    function bandFor(score) {
      for (var i = 0; i < bands.length; i++) {
        if (score >= bands[i].min) return bands[i];
      }
      return bands[bands.length - 1];
    }

    function set(key, value) {
      if (out[key]) out[key].textContent = value;
    }

    function showOne(map, activeKey) {
      Object.keys(map).forEach(function (k) {
        map[k].hidden = k !== activeKey;
      });
    }

    var copyTimer = null;
    var last = null;

    function render() {
      var option = verticalSelect.options[verticalSelect.selectedIndex];
      var target = Number(option.getAttribute('data-target'));
      var verticalNote = option.getAttribute('data-note') || '';
      var verticalLabel = tidy(option);

      var revenue = clampMoney(numOr0(fields.revenue.value));
      var repeatRate = clampPercent(numOr0(fields.repeatRate.value));
      var ownedShare = clampPercent(numOr0(fields.ownedShare.value));
      var mixShare = clampPercent(numOr0(fields.mixShare.value));

      var liveFlows = flows.filter(function (f) {
        return f.input.checked;
      });
      var missingFlows = flows.filter(function (f) {
        return !f.input.checked;
      });

      // Each pillar is 0-100. Exceeding a target caps rather than banking credit
      // that would mask a weak pillar elsewhere.
      var repeatScore = target > 0 ? Math.min(100, (repeatRate / target) * 100) : 100;
      var mixScore = MIX_TARGET > 0 ? Math.min(100, (mixShare / MIX_TARGET) * 100) : 100;
      var coverageScore = liveFlows.reduce(function (sum, f) {
        return sum + f.weight;
      }, 0);

      var score = Math.round(
        repeatScore * W_REPEAT + mixScore * W_MIX + coverageScore * W_COVERAGE
      );
      var band = bandFor(score);

      var ownedRevenue = revenue * (ownedShare / 100);
      var flowRevenue = ownedRevenue * (mixShare / 100);

      // Conservative: re-prices existing owned revenue against the benchmark and
      // does not assume the total grows.
      var automationGap = Math.round(
        Math.max(0, (MIX_TARGET - mixShare) / 100) * ownedRevenue * 12
      );
      // Directional: one point of repeat-rate lift as roughly one point of revenue.
      var repeatGap = Math.round(Math.max(0, (target - repeatRate) / 100) * revenue * 12);

      var shortBy = Math.max(0, target - repeatRate);

      // ── Category ──
      set('verticalTarget', target + '%');
      set('verticalNote', verticalNote);
      set('targetInline', String(target));

      // ── Score ──
      set('score', String(score));
      set('bandLabel', band.label);

      // ── Summary: fill slots, then reveal the one that applies ──
      set('ownedRevenue1', money(ownedRevenue));
      set('ownedRevenue2', money(ownedRevenue));
      set('mixShare1', pct(mixShare));
      set('flowRevenue1', money(flowRevenue));
      set('flowRevenue2', money(flowRevenue));
      set('revenue1', money(revenue));
      set('liveCount1', String(liveFlows.length));
      set('flowTotal1', String(flows.length));
      showOne(summaries, revenue === 0 ? 'zero' : band.key);

      // ── Gap tiles ──
      set('automationGap', money(automationGap));
      set('repeatGap', money(repeatGap));
      if (notes['automation-year']) notes['automation-year'].hidden = automationGap <= 0;
      if (notes['automation-clear']) notes['automation-clear'].hidden = automationGap > 0;
      if (notes['repeat-year']) notes['repeat-year'].hidden = repeatGap <= 0;
      if (notes['repeat-clear']) notes['repeat-clear'].hidden = repeatGap > 0;

      // ── Bars ──
      var maxBar = Math.max(mixShare, MIX_TARGET, 1);
      set('mixShare2', pct(mixShare));
      if (out.mixBar) out.mixBar.style.width = (mixShare / maxBar) * 100 + '%';
      if (out.benchBar) out.benchBar.style.width = (MIX_TARGET / maxBar) * 100 + '%';

      // ── Caveat line ──
      set('repeatRate1', pct(repeatRate));
      set('target1', String(target));
      set('shortBy', shortBy > 0 ? ', ' + pct(shortBy) + ' short' : '');
      set('liveCount2', String(liveFlows.length));
      set('flowTotal2', String(flows.length));
      set('coverage', String(coverageScore));

      if (missingFlows.length) {
        set(
          'missingFlows',
          missingFlows
            .slice(0, 2)
            .map(function (f) {
              return f.name.toLowerCase();
            })
            .join(', then ')
        );
        showOne(priorities, 'missing');
      } else {
        showOne(priorities, mixShare >= MIX_TARGET ? 'clear' : 'underperforming');
      }

      last = {
        score: score,
        bandLabel: band.label,
        verticalLabel: verticalLabel,
        target: target,
        revenue: revenue,
        repeatRate: repeatRate,
        ownedShare: ownedShare,
        mixShare: mixShare,
        liveCount: liveFlows.length,
        flowTotal: flows.length,
        coverageScore: coverageScore,
        repeatScore: repeatScore,
        mixScore: mixScore,
        ownedRevenue: ownedRevenue,
        flowRevenue: flowRevenue,
        automationGap: automationGap,
        repeatGap: repeatGap,
        missing: missingFlows.map(function (f) {
          return f.name;
        })
      };
    }

    function weightLabel(w) {
      return Math.round(w * 100) + '%';
    }

    function copySummary() {
      if (!last || !navigator.clipboard) return;
      var status = root.querySelector('[data-ret-status]');
      var btn = root.querySelector('[data-ret-copy]');

      var text = [
        'Retention Revenue Score (Shero Commerce)',
        'Score: ' + last.score + '/100 (' + last.bandLabel + ')',
        'Category: ' + last.verticalLabel + ', target repeat rate ' + last.target + '%',
        'Monthly revenue: ' + money(last.revenue),
        'Repeat purchase rate: ' + pct(last.repeatRate) + ' (target ' + last.target + '%)',
        'Email + SMS share of revenue: ' + pct(last.ownedShare),
        'Automated share of owned revenue: ' + pct(last.mixShare) + ' (benchmark ' + MIX_TARGET + '%)',
        'Lifecycle flows live: ' + last.liveCount + ' of ' + last.flowTotal + ' (' + last.coverageScore + '/100 weighted)',
        'Pillars: repeat ' + Math.round(last.repeatScore) + '/100 (' + weightLabel(W_REPEAT) + '), automated mix ' + Math.round(last.mixScore) + '/100 (' + weightLabel(W_MIX) + '), coverage ' + Math.round(last.coverageScore) + '/100 (' + weightLabel(W_COVERAGE) + ')',
        'Owned revenue: ' + money(last.ownedRevenue) + '/mo, of which ' + money(last.flowRevenue) + ' is automated',
        'Automation gap: ' + money(last.automationGap) + '/yr to reach the ' + MIX_TARGET + '% benchmark',
        'Repeat-rate gap: ' + money(last.repeatGap) + '/yr to reach the ' + last.target + '% category target',
        'These two gaps overlap, so do not add them together.',
        'Flows not live: ' + (last.missing.length ? last.missing.join(', ') : 'none')
      ].join('\n');

      navigator.clipboard.writeText(text).then(function () {
        if (btn) {
          btn.textContent = '✓ Copied!';
          btn.classList.add('tool__btn--copied');
        }
        if (status) status.textContent = 'Result summary copied to clipboard.';
        clearTimeout(copyTimer);
        copyTimer = setTimeout(function () {
          if (btn) {
            btn.textContent = 'Copy result summary';
            btn.classList.remove('tool__btn--copied');
          }
          if (status) status.textContent = '';
        }, 2500);
      });
    }

    verticalSelect.addEventListener('change', render);
    Object.keys(fields).forEach(function (key) {
      fields[key].addEventListener('input', render);
    });
    flows.forEach(function (f) {
      f.input.addEventListener('change', render);
    });

    var copyBtn = root.querySelector('[data-ret-copy]');
    if (copyBtn) copyBtn.addEventListener('click', copySummary);

    var printBtn = root.querySelector('[data-ret-print]');
    if (printBtn) {
      printBtn.addEventListener('click', function () {
        window.print();
      });
    }

    render();
  }

  // Marked only after a clean mount, so free-tools.liquid reveals its fallback table if setup throws.
  for (var r = 0; r < roots.length; r++) {
    mount(roots[r]);
    roots[r].setAttribute('data-tool-ready', '');
  }
})();
